module.exports = __webpack_public_path__ + "static/ChronicleDisp-XLight-0163f6f7171dc50ca1d083b328868645.otf";